import { client } from "api";
import { Category } from "models/Checklist";
import { OrderStatus } from "models/Order";
import { SimpleOrder } from "models/SimpleOrder";

export type SortBy = "ordernr" | "companyName" | "orderStatus" | "lastStatusUpdate" | "updatedAt" | "reviewedAt";
export type SortDir = "asc" | "desc";

export const SORT_BY = {
  ordernr: "ORDER_NUMBER",
  companyName: "COMPANY",
  orderStatus: "ORDER_STATUS",
  lastStatusUpdate: "ORDER_STATUS_UPDATED",
  updatedAt: "LAST_UPDATE",
  reviewedAt: "REVIEWED_AT",
} as const;

export const SORT_DIR = {
  asc: "ASC",
  desc: "DESC",
} as const;

export type GetOrdersRequest = {
  filterText?: string | null;
  filterByReferenceOrder?: boolean | null;
  filterByHasReferenceContact?: boolean | null;
  filterByReferenceContactName?: string | null;
  filterOnlyCustomerFollowUpNotDone?: boolean | null;
  filterByOrderStatus?: OrderStatus | null;
  filterNotRatedChecklists?: boolean | null;
  filterBySellerSignature?: string | null;
  filterByCompanyCode?: string | null;
  filterByRoomCategory?: Category | null;
  coordinator?: string | null;
  selectedForReview?: boolean | null;
  reviewed?: boolean | null;
  fromDate?: string | null;
  toDate?: string | null;
  sortBy: SortBy;
  sortDir: SortDir;
  pageSize?: number | null;
};

export type GetOrdersResponse = {
  page: number;
  pageCount: number;
  orders: SimpleOrder[];
} | null;

export const getOrders = ({ sortBy, sortDir, ...params }: GetOrdersRequest) =>
  client
    .post<GetOrdersResponse>(`/order/page`, {
      ...params,
      sort: {
        sortBy: !!sortBy ? SORT_BY[sortBy] : null,
        sortType: !!sortDir ? SORT_DIR[sortDir] : null,
      },
    })
    .then((res) => res.data);
